// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t4i8Q","type":"styles_type__2mK6y","choices":"styles_choices__8Lgjc"};